import React from 'react'

const RecentBookings = ({recentOrders}) => {

    const showTimeSlot = recentOrders?.some(order => order?.orderType === "PASSPORT_PHOTO_SHOOT");
    return (
        <section className="col-lg-8 connectedSortable">
            <div className="card">
                <div className="card-header border-0 pb-0">
                    <div className="row">
                        <div className="col-sm-6">
                            <h4 className="card-title float-none">
                                Recent Bookings
                            </h4>
                            {/* <p className="f-14">List View</p> */}
                        </div>
                        {/* <div className="col-sm-6 text-sm-right">
                            <p className="mt-3 mb-0">
                                Showing results from{" "}
                                <strong>Feb 2025 - July 2025</strong>{" "}
                            </p>
                        </div> */}
                    </div>
                </div>
                <div className="card-body pt-0">
                    <div className="table-responsive">
                        <table className="table booking-table table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Order No</th>
                                    <th>Customer</th>
                                    <th>Service</th>
                                    <th>Payment</th>
                                    {showTimeSlot && <th>Time Slot</th>}
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentOrders && recentOrders.length > 0 ? recentOrders.map((order, index) => (
                                    <tr key={order.id}>
                                        <td>#{index + 1}</td>
                                        <td>{order?.orderNo}</td>
                                        <td>{order?.customerInfo?.userName}</td>
                                        <td>{order?.serviceInfo?.name}</td>
                                        <td>${Number(order?.priceInfo?.payableAmount).toFixed(2)}</td>
                                         {showTimeSlot && (
                                        <td>
                                            {order?.orderType === "PASSPORT_PHOTO_SHOOT"
                                                ? `${order?.scheduleFromTime} - ${order?.scheduleToTime}`
                                            : "-"}
                                        </td>)}
                                        <td>{order?.status}</td>
                                    </tr>
                                )) :

                                <tr>
                                    <td colSpan="5" className="text-center">No recent orders found.</td>
                                </tr>
                                }
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RecentBookings